var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page != 'elipsis')?_c('button',{staticClass:"pagination-button page-number",class:{ current: _vm.iscurrent },on:{"click":_vm.changePage}},[_vm._v(" "+_vm._s(_vm.page)+" ")]):_c('div',{staticClass:"elipsis"},[_vm._v("...")])}
var staticRenderFns = []

export { render, staticRenderFns }